import { createApp} from 'vue';
import App from './App.vue';
import { router } from './router';
import axios from 'axios';
import { Cell, Button, Notify,Picker, Popup ,ConfigProvider,Tab, Tabs, Collapse, CollapseItem, Dialog, Toast } from 'vant';
import 'vant/es/dialog/style';
import 'vant/es/toast/style';
import 'vant/es/image-preview/style';
import { thousands } from "@/api/utils/thousands.js";

const app = createApp(App);
app.use(router);
app.config.globalProperties.Axios=axios;
app.use(Cell);
app.use(Button);
app.use(Notify);
app.use(Picker);
app.use(Popup);
app.use(ConfigProvider);
app.use(Tab);
app.use(Tabs);
app.use(Collapse);
app.use(CollapseItem);
app.use(Dialog);
app.use(Toast);
app.use(thousands);
app.mount('#app');